import React, { Component } from 'react'
import T from 'i18n-react'

import RangeInput from 'components/fulcrum/input/RangeInput'
import FormTitle from 'components/fulcrum/formTitle/FormTitle'


class PcbLayerCount extends Component {
  onLayerCountChange = (layerCount) => {
    this.props.onLayerCountChange(parseInt(layerCount))
  }

  render() {
    const { layerCount, minLayerCount, maxLayerCount } = this.props
    const layerCountInput = <RangeInput 
                              value={ (layerCount && layerCount[0]) ? parseInt(layerCount[0].value) : 2 } 
                              min={minLayerCount}
                              max={maxLayerCount}
                              onChange={ this.onLayerCountChange } 
                              hint='Input PCB Layer Count' 
                            />

    return (
      <FormTitle title={'PCB Layer Count'}>
        {layerCountInput}
      </FormTitle>
    )
  }
}

export default PcbLayerCount
